<template>
	<div class="stationNotice">
		<div class="station_right">
			<div class="station_right_in">
				<h2 class="station_right_h2">站内通知
					 	<p class="station_right_h2_right">
						 	<a href="javascript:void(0);" class="station_right_h2_red">
						 		<span v-text="msgCount"></span>&nbsp;条未读
						 	</a>
						 	<a href="javascript:void(0);" class="station_right_h2_sub" @click="markedRead">全部标为已读</a>
					    </p>
				   </h2>

				<!--中间通知部分内容需要循环-->
				<div v-for="(item,key) in list" @click="clickItemFun(item)" :class="addClass(item.readState)"   >
					<div class="msg_top_staNotice">
						<span class="msg_item_notice_h3">
						<span class="notice_msg_title" v-text="item.title">接口更新通知</span>
						<span class="msg_item_time fr" v-text="item.createTime"></span>
						</span>
						<p :class="addClassSecond(item)" v-text="item.context"></p>
						<!--<a class="msg_item_down_btn" v-show="more_btn" >-->
						<i v-if='item.iconShow' :class="iconClass(item)" @click="lookMore($event,item)"></i>						
						<!--</a>-->
					</div>
				</div>
				<!--未读状态加unread-->
				<!--<div class="msg_item unread">
						<div class="msg_top_staNotice">
							<span class="msg_item_notice_h3">
									<span class="notice_msg_title">接口更新通知</span>
									<span class="msg_item_time fr">2017-10-28 10:32:23</span>
							</span>
							<p class="msg_item_top_p">近期我们对xxx接口进行了更新</p>
							<a href="javascript:;" class="msg_item_down_btn"><i class="msg_item_arrow down"></i></a>
						</div>
					</div>-->

				<div class="noNewsCon" v-show="noNews">您暂时没有任何消息</div>
				<!--分页-->
				<div v-show="pageSizeStatue" class="paginatBox">
					<Page :total="numTotal" :page-size='pageSize' @on-change='pageChange'></Page>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	export default {
		name: "stationNotice",
		data() {
			return {
				noNews: false, //当站内通知没有任何通知的时候出现的提示信息
				pageSizeStatue: false, //当站内没有任何通知的时候会出现的分页消失。
				list: {},
				numTotal: 0, //用户通知条数
				more_btn: true,
				msgId: "",
				pageSize: 5,
				userdevId: sessionStorage.getItem('devId') || 1,
				isShow:false,      //这个是控制超过45个字符的时候出现以...显示 的状态，及控制内容区域的P标签。
				iconShow:false     //这个是控制下拉 、上拉箭头的标志的 up down ,默认是down及可以展开。
			}
		},
		computed: {
			...mapState([
				'msgCount'
			])
		},
		methods: {
			//全部标记为已读方法
			markedRead() {
				let markParam = {
					"devId": this.userdevId
				};
				if(this.msgCount == 0) {
					this.$Message.warning('您暂时没有未读通知，不能标记哦！');
				} else {
					this.http.post('/ystOpenPlatformBff/readMsgAll', markParam, res => {
						if(res.success) {
							this.initNews();
							this.getMsgCount();
							location.reload();
						}else{
							this.$Message.error(res.message);
						}
					})
				}
			},
			//切换页数
			pageChange(pageNum) {
				this.initNews(pageNum)
			},
			addClass(readState) {
				if(readState == 0) {
					return 'msg_item unread';
				} else {
					return 'msg_item';
				}
			},
			//省略内容
			addClassSecond(item) {
				let len = item.context.length;
				if(len > 45) {
					item.iconShow = true;    
				}
				if(item.isShow){     
					return 'msg_item_top_p';
				}else{
					return 'msg_item_top_p overClass';
				}
			},
			iconClass(item){
				if(item.isShow){
					return 'msg_item_arrow up';
				}else{
					return 'msg_item_arrow down';
				}
			},
			//查看更多的时候会添加样式，让下面的多余内容展开
			lookMore(event,item) {
				if(item.isShow){
					item.isShow = false;
				}else{
					item.isShow = true;
				}
				event.cancelBubble = true;  //解决冒泡事件
				this.clickItemFun(item);  //查看更多的时候将当前的通知信息标记成已读。
			},
			//控制I标签的class的名字的up  或者down 的。
			addclassMore(item){
				if(item.isShow = false){
					item.isShow = true;  // 是控制超过45个字符的时候出现以...显示 的状态，及控制内容区域的P标签。
					item.iconShow = false;  //显示下拉箭头变成down  
				}else{
					item.isShow = false;  // 点击全部显示P标签内的内容，及去掉overClass的名字
					item.iconShow = true;  //显示下拉箭头变成up
				}
			},
			// 点击当前的通知的时候，标记成已读
			clickItemFun(item) {
				const _this = this;
				let clickItemParam = {
					"devId":this.userdevId,
					"msgId": item.msgId
				};
				if(item.readState == 0) {
					this.http.post('/ystOpenPlatformBff/editMsgInfo', clickItemParam, res => {
						if(res.success) {
							
							this.initNews();
							return 'msg_item';
						} else {
							return 'msg_item unread';
							this.$Message.error(res.message);
						}
					})
				}
			},
			//初始化消息
			initNews(pageNum) {
				var num = pageNum || 1;
				var that = this;
				//站内通知信息
				let statNewsParams = {
					"devId":this.userdevId,
					//"readState":"0",
					"pageNum": num,
					"pageSize": "5"
				};
				this.http.post('/ystOpenPlatformBff/getMsgInfo', statNewsParams, res => {
					if(res.success){
						if(res.data.list.length == 0) {
							that.noNews = true;
						} else {
							that.noNews = false;
							that.pageSizeStatue = true;
							 //用户循环通知的list对象
							that.numTotal = res.data.total; //用户总的通知条数，先储存起来。用于以后的调用
							
							var centerNumList = res.data.list;
							for(var i = 0,len = centerNumList.length;i < len; i++){
								centerNumList[i].isShow = false;
								centerNumList[i].iconShow = false;
						   }
						   that.list = res.data.list;
							
						}
					}else{
						this.noNews = true;
						//this.$Message.error(res.message);
					}
					
				})
			},
			getMsgCount(){
				//站内通知 未读内容
				const that = this;
				let statParams = {
					"devId": this.userdevId
				};
				this.http.post('/ystOpenPlatformBff/getMsgCount', statParams, res => {
					if(res.success) {
						this.$store.dispatch('changeMsgCount',res.data.msgCount)
					} else {
						this.$Message.error(res.message);
					}
				})
			}
			
		},
		mounted() { //相当于document.ready后执行的方法 ，DOM元素全部都加载完成之后执行的方法 
		
			this.getMsgCount()
			this.initNews(1)
//			//站内通知信息
//			let statNewsParams = {
//				"devId": this.userdevId,
//				//"readState":"0",
//				"pageNum": "1",
//				"pageSize": "5"
//			};
//			this.http.post('/ystOpenPlatformBff/getMsgInfo', statNewsParams, res => {
//				if(res.data.list.length == 0) {
//					that.noNews = true;
//				} else {
//					that.noNews = false;
//					that.pageSizeStatue = true;
//					for(var i = 0,len = res.data.list.length;i<len;i++){
//						res.data.list[i].isShow = false;
//						res.data.list[i].iconShow = false;
//					}
//					that.list = res.data.list; //用户循环通知的list对象
//					if(res.data.total) {
//						that.numTotal = parseInt(res.data.total);
//					}
//					//用户总的通知条数，先储存起来。用于以后的调用        
//				}
//			})

		}
	}
</script>

<style lang="scss">
	.station_right_h2_sub {
		color: $gredF;
	}
	
	.msg_item_notice_h3 {
		font-size: 14px;
		line-height: 20px;
	}
	
	.msg_item_top_p {
		line-height: 24px;
		font-size: 14px;
		color: $stationWord;
		padding-right: 30px;
	}
	
	.overClass {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.msg_item_down_btn{
		display: inline-block;
		width: 30px;
		height: 30px;
		background: red;
	}
	.msg_top_staNotice {
		background: $base;
		border: 1px solid $baseBord;
		width: 720px;
		position: relative;
		margin-bottom: 20px;
		padding: 8px 10px 12px;
	}
	
	.msg_top_staNotice span {
		color: $title;
		font-size: 14px;
	}
	
	.stationNotice {
		.notice_msg_title {
			font-weight: bold;
		}
		.msg_item.unread .msg_top_staNotice {
			background: $stationbg;
			border-color: $stationbord;
		}
	}
	
	.msg_item {
		cursor: pointer;
	}
	
	.noNewsCon {
		text-align: center;
		border-top: 1px solid $baseBord;
		padding-top: 30px;
	}
	/**箭头图标**/
	
	.msg_item_arrow {
		width: 11px;
		height: 11px;
		position: absolute;
		right: 10px;
		top: 37px;
	}
	
	.msg_item_down_btn {
		position: absolute;
		right: 7px;
		bottom: 7px;
		padding: 0 5px;
	}
	
	.msg_item_arrow.down {
		background: url(../../assets/images/arrow_down.png) no-repeat;
	}
	
	.msg_item_arrow.up {
		background: url(../../assets/images/arrow_up.png) no-repeat;
	}
	.paginatBox{margin-top: -10px;text-align: center;}
</style>


// WEBPACK FOOTER //
// src/components/_developCenter/StationNotice.vue